import { render, staticRenderFns } from "./TeamRecord.vue?vue&type=template&id=75c0c3e4&"
import script from "./TeamRecord.vue?vue&type=script&lang=js&"
export * from "./TeamRecord.vue?vue&type=script&lang=js&"
import style0 from "./TeamRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports